import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  addEstimate,
  createJob,
  fetchJobPortalData,
  fetchJobs,
  approveEstimate,
  deleteAttachment,
  setEstimatePreview,
  navigateToEstimateCreation,
  deleteEstimate,
  setAttachmentPreview,
  fetchAttachment,
  addAttachmentSuccess,
  addAttachmentError,
  saveNote,
  convertToInvoice,
} from './job-data.actions';
import { Attachments } from './models/submodels/attachments.model';

@Injectable()
export class JobDataDispatcher {
  constructor(private _store: Store<any>) {}

  fetchJobs(clientId: string) {
    this._store.dispatch(fetchJobs(clientId));
  }

  fetchJobPortalData(jobId: string) {
    this._store.dispatch(fetchJobPortalData(jobId));
  }

  createJob(clientId: string) {
    this._store.dispatch(createJob(clientId));
  }

  addEstimate(documentId: string, jobId: string) {
    this._store.dispatch(addEstimate(documentId, jobId));
  }

  approveEstimate(documentId: string) {
    this._store.dispatch(approveEstimate(documentId));
  }

  deleteAttachment(attachmentId: string, jobId: string) {
    this._store.dispatch(deleteAttachment(attachmentId, jobId));
  }

  deleteEstimate(documentId: string, jobId: string) {
    this._store.dispatch(deleteEstimate(documentId, jobId));
  }

  setEstimatePreview(documentId: string) {
    this._store.dispatch(setEstimatePreview(documentId));
  }

  setAttachmentPreview(attachment: Attachments) {
    this._store.dispatch(setAttachmentPreview(attachment));
  }

  navigateToEstimateCreation(clientId: string, jobId: string) {
    this._store.dispatch(navigateToEstimateCreation(clientId, jobId));
  }

  fetchAttachment(attachmentId: string, jobId: string) {
    this._store.dispatch(fetchAttachment(attachmentId, jobId));
  }

  addAttachmentSuccess(attachment: Attachments) {
    this._store.dispatch(addAttachmentSuccess(attachment));
  }

  addAttachmentError(error: Error) {
    this._store.dispatch(addAttachmentError(error));
  }

  saveNote(content: string, jobId: string) {
    this._store.dispatch(saveNote(content, jobId));
  }

  convertToInvoice(documentId: string, jobId: string, clientId: string) {
    this._store.dispatch(convertToInvoice(documentId, jobId, clientId));
  }
}
